import useAuthRequest from "../../../../services/state/request/useAuthRequest";
import useValueChangeListener from "../../../../services/state/general/useValueChangeListener";
import {useSelector} from "react-redux";
import {condition, request} from "../../../../../res/rest/restRequest";
import HttpClient from "../../../../services/http/HttpClient";
import {api} from "../../../../../res/rest/api";
import {env} from "../../../../../res/config/env";

const useTax = () => {

    const { orderID } = useSelector(
        state => state.session.cart
    )
    const {
        loading,
        error,
        result,
        sendIt
    } = useAuthRequest();

    const getTaxLines = () => {
        if(!orderID || orderID <= 0) return;

        const req = request.model("c_ordertax")
            .select("TaxBaseAmt", "TaxAmt")
            .filter(condition.eq("c_order_ID", orderID))
            .expand(request
                .subQuery("c_tax_ID")
                .select("rate")
            );

        const sendReq = async (authSession) => {
            const resp = await HttpClient.client.get(req.buildRequest(env.API_URL), api.auth(authSession));
            return resp.data.records;
        }

        sendIt(sendReq);
    }


    useValueChangeListener(getTaxLines, [orderID], []);


    return {
        loading,
        error,
        taxLines: result
    }
}

export default useTax;